import type { IconDef } from '../types';

export const medicationBottle: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M15.9946 4.04831V1.49938C15.9946 0.669721 15.3249 0 14.4952 0H8.49771C7.66806 0 6.99833 0.669721 6.99833 1.49938V4.04831C4.74927 4.3182 3 6.20741 3 8.52645V19.4719C3 21.9708 5.02915 24 7.52811 24H15.4748C17.9738 24 20.0029 21.9708 20.0029 19.4719V8.52645C20.0029 6.20741 18.2536 4.3182 16.0046 4.05831L15.9946 4.04831ZM8.9975 1.99917H13.9954V3.99833H8.9975V1.99917ZM7.87797 5.82757L15.8147 6.17743C17.2041 6.2374 18.2836 7.41691 18.2237 8.80633V9.14619H8.34777C7.798 9.14619 7.34819 9.596 7.34819 10.1458C7.34819 10.6955 7.798 11.1454 8.34777 11.1454H18.1237L17.8738 16.833H4.86922L5.24906 8.23657C5.30904 6.84715 6.48855 5.7676 7.87797 5.82757ZM15.115 22.1508L7.17826 21.8009C5.78884 21.7409 4.70929 20.5614 4.76926 19.172V18.8322H17.7838L17.7439 19.7418C17.6839 21.1312 16.5044 22.2107 15.115 22.1508Z',
    },
  ],
};
